if (!customElements.get("instagram-carousel")) {
  class a extends HTMLElement {
    constructor() {
      if (
        (super(),
        (this.app =
          this.querySelector(".instafeed-shopify") ||
          this.querySelector("#insta-feed")),
        this.app)
      ) {
        ((this.media = window.matchMedia("(min-width: 1200px)")),
          this.media.addEventListener("change", () => this.onResize()),
          (this.swiper = void 0),
          (this.items = this.querySelector(".swiper-wrapper")),
          (this.container = this.querySelector(".swiper-container")),
          (this.scrollbar = this.querySelector(".swiper-scrollbar")));
        let i = new MutationObserver((e) => {
          e.forEach((e) => {
            e.target
              .querySelectorAll(".instafeed-new-layout-item")
              .forEach((e) => {
                var s = document.createElement("div");
                (s.classList.add("swiper-slide"),
                  s.classList.add("card"),
                  s.append(e),
                  this.items.append(s),
                  5 === this.items.querySelectorAll(".swiper-slide").length &&
                    i.disconnect());
              });
          });
        });
        (i.observe(this.app, { subtree: !1, childList: !0 }), this.onResize());
      }
    }
    onResize() {
      this.media.matches
        ? void 0 !== this.swiper &&
          (this.swiper.destroy(), (this.swiper = void 0))
        : void 0 === this.swiper &&
          (this.swiper = new Swiper(this.container, {
            loop: !1,
            grabCursor: !0,
            speed: 500,
            spaceBetween: 8,
            slidesPerView: 3,
            scrollbar: { el: this.scrollbar, enabled: !0 },
            breakpoints: { 992: { spaceBetween: 16, slidesPerView: 4 } },
          }));
    }
  }
  customElements.define("instagram-carousel", a);
}
